import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation(); // Detects page changes

  // Show or hide the button based on scroll position
  const toggleVisibility = () => {
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = window.scrollY;
    const clientHeight = window.innerHeight;

    // Calculate scroll percentage
    const scrolledPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;

    setIsVisible(scrolledPercentage > 30);
  };

  // Scroll to top manually
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Automatically scroll to top on page change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  }, [location]);

  // Attach and detach scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div>
      {isVisible && (
        <button
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: '50px',
            right: '50px',
            backgroundColor: '#0049AC',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            fontSize: '20px',
            cursor: 'pointer',
            boxShadow: '0px 4px 6px rgb(255, 255, 255)',
            zIndex:'10'
          }}
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default ScrollTop;
